<template>
  <modal name="bulk-task-view" height="auto">
    <div class="task-modal-head" v-if="task.reference">
      <div class="task-modal-close">
        <a @click="$modal.hide('bulk-task-view')"> &times; </a>
      </div>
      <div
        class="px-4 pt-5 px-md-4 pt-md-5 main-title-modal d-flex justify-content-between"
      >
        <p>
          {{ $t("task.view.createdBy") }}: {{ task.createdBy.firstName }}
          {{ task.createdBy.lastName }} ({{
            formatDate(task.createdBy.creationDate)
          }})
        </p>
        <p v-if="task.dueDate">
          {{ $t("task.view.due") }}: {{ formatDate(task.dueDate) }}
        </p>
      </div>
      <div class="modal-head-description mb-2">
        <ul class="heading-unorder">
          <li>
            <h3>{{ $t("task.view.description") }}</h3>
          </li>
          <li>
            <ul>
              <li>
                <button
                  type="button"
                  class="mx-1 mx-md-1 del-btn"
                  @click="$emit('deleteTask', task.reference)"
                >
                  {{ $t("task.view.delete") }}
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="mx-md-1 edit-btn"
                  @click="editTask()"
                >
                  {{ $t("task.view.edit") }}
                  <img src="@/assets/images/edit.svg" />
                </button>
              </li>
            </ul>
          </li>
        </ul>
        <div></div>
      </div>
      <div class="modal-des-2 px-4">
        <p>
          {{ task.description }}
        </p>
      </div>
      <div class="modal-tabel-2">
        <table class="table modal-2-table table-borderless">
          <thead>
            <tr class="d-flex">
              <th style="width: 25%">{{ $t("task.table.AssignedTo") }}</th>
              <th style="width: 50%; text-align: center"></th>
              <th style="width: 25%; text-align: center">
                {{ $t("task.table.Status") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="d-flex" v-for="(user, index) in task.users" :key="index">
              <td
                style="width: 25%; text-align: left"
                @click="showTaskDetail(task, user)"
              >
                {{ user.firstName }} {{ user.lastName }}
              </td>
              <td style="width: 50%; text-align: center">
                <button
                  type="button"
                  class="mx-1 mx-md-1 send-noti-btn"
                  @click="sendNotification(user, 'vous a envoyé un rappel')"
                >
                  {{ $t("global.notification") }}
                </button>
              </td>
              <td style="width: 25%; text-align: center">
                <div :class="user.status">
                  <select
                    class="peding-done-select"
                    v-model="user.status"
                    @change="updateStatus(user, user.status)"
                  >
                    <option value="pending">{{ $t("global.pending") }}</option>
                    <option value="Done">{{ $t("global.done") }}</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>
<script>
import TimeUtils from '../../utils/TimeUtils';
import TaskHelper from '../../helper/TaskHelper';

export default {
  props: ['task'],

  mounted() {
    this.user = this.$store.state.user.informations;
  },

  data() {
    return {
      user: {},
    };
  },

  methods: {
    formatDate(date) {
      return date && TimeUtils.dayMonYear(date);
    },

    showTaskDetail(task, user) {
      this.$modal.hide('bulk-task-view');
      const users = [];
      users.push(user);
      const obj = {
        task,
      };
      this.$emit('showTask', obj, users);
      this.$modal.show('simple-task');
      this.$root.$emit('simpleTaskView', task.reference);
    },

    updateStatus(emp, status) {
      const emps = [];
      emps.push(emp);
      const st = TaskHelper.updateStatus(this.task, status, this.user, emps);
      if (st) {
        this.$miniToastr.success(this.$t('global.updateToaster'));
        const desc = `${this.$t('task.statusSentence')} ${
          status == 'pending' ? 'À faire' : 'Terminé'
        }`;
        this.sendNotification(emps[0], desc);
      } else {
        this.$miniToastr.error(this.$t('global.noUpdateToaster'));
      }
    },

    notificationDescription(desc) {
      return `${this.task.createdBy.firstName} ${this.task.createdBy.lastName} ${desc} pour la tâche : ${this.task.title}`;
    },

    async sendNotification(user, desc) {
      const description = this.notificationDescription(desc);
      const users = [];
      users.push(user);
      const status = TaskHelper.sendNotification(this.task, users, description);
      status
        ? this.$miniToastr.success(this.$t('global.notificationToaster'))
        : this.$miniToastr.error('global.noNotificationToaster');
    },

    editTask() {
      this.$modal.hide('bulk-task-view');
      this.$modal.show('edit-task');
      this.$root.$emit('editTask', this.task);
    },
  },
};
</script>
<style lang="scss" scoped>
.task-modal-head {
  position: relative;
  min-height: 550px;
  height: 550px;
  overflow-y: auto;
  .task-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
  .modal-head-description {
    .description-unorder {
      margin: 0;
      padding: 0;
    }
    li {
      display: inline-block;
      margin-right: 5px;
      ul {
        padding-left: 25px;
        li {
          padding: 0px;
          margin: 0px;
        }
      }
      h3 {
        font-size: 26px;
        font-family: "SF-Pro-Text";
        color: #212529;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 17px;
        }
      }
      span {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }

  .modal-description-pera {
    background-color: #f6f8ff;
    padding: 20px 0;
    p {
      font-size: 16px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 14px;
      }
    }
  }
  .modal-comment-section {
    box-shadow: 0 0 2px 0 #b9bbd1;
    margin-bottom: 7px;
    padding: 18px 0;
    .modal-comment-profile {
      background-color: #b9bbd1;
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-radius: 60px;
      margin-top: -1px;
      margin-bottom: 12px;
      @media (min-width: 320px) and (max-width: 600px) {
        height: 40px;
        width: 40px;
        border-radius: 40px;
        margin: 10px 10px 0 0;
      }
      p {
        margin: 0;
        font-size: 20px;
        color: #fff;
        font-family: "SF-Pro-Text";
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 15px;
        }
      }
    }
    .modal-comment-text {
      width: 85%;
      margin-left: 20px;
      @media (min-width: 320px) and (max-width: 600px) {
        margin-left: 5px;
      }
      h3 {
        margin: 0;
        font-size: 20px;
        font-family: "SF-Pro-Text";
        color: #303778;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 16px;
        }
      }
      p {
        text-align: justify;
        line-height: normal;
        color: #212529;
        font-family: "SF-Pro-Text";
        margin: 0;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 12px;
        }
      }
      textarea {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        border: solid 1px #becad6;
        resize: none;
        outline: none;
        padding: 10px;
        @media (min-width: 320px) and (max-width: 600px) {
          margin-bottom: 20px;
        }
      }
    }
    .comment-submit-btn {
      background-color: #4f78e1;
      height: 35px;
      color: #fff;
      margin-top: 10px;
      font-family: "SF-Pro-Text";
      outline: none;
      padding: 4px 15px;
      border: none;
      margin-left: 10px;
      border-radius: 3px;
    }
  }
}
tr {
  cursor: pointer;
}
.file-upload-btn-wrapper {
  position: relative;
  display: inline-block;
}
.cross-attachment {
  width: 20px;
  text-align: center;
  position: relative;
  left: 5px;
  top: 3px;
  border-radius: 5px;
  background-color: #eee;
  cursor: pointer;
}
.Done {
  position: relative;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    width: 120px;
    object-fit: contain;
    border-radius: 3px;
    border: none;
    background-color: transparent !important;
    color: #17c671 !important;
    font-family: "SF-Pro-Text";
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 14px;
    margin: 0 auto !important;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-done.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
  width: 120px;
  height: 30px;
  object-fit: contain;
  border-radius: 3px;
  border: solid 1px #17c671;
  background-color: rgba(23, 198, 113, 0.24) !important;
  color: #17c671 !important;
  font-family: "SF-Pro-Text";
  box-shadow: none !important;
  font-size: 11px;
}
.pending {
  position: relative;
  width: 120px;
  height: 30px;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    object-fit: contain;
    border-radius: 3px;
    border: solid 1px #ffb400;
    background-color: rgba(255, 180, 0, 0.24) !important;
    color: #ffb400 !important;
    font-family: "SF-Pro-Text";
    margin: 0 auto;
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 20px;
    width: 120px;
  }
  &:before {
    display: none;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-pending.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
}
.send-noti-btn {
  border: 1px solid #4f78e1;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 3px;
  color: #4f78e1;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-size: 14px;
  outline: none !important;
  &:focus {
    outline: none;
  }
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
}
.del-btn {
  background-color: #fddad5;
  padding: 4px 15px;
  border-radius: 3px;
  color: #fc452d;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  border: 0;
  font-size: 14px;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
}
.edit-btn {
  border: 1px solid #becad6;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 3px;
  color: #5a6169;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-size: 14px;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
  img {
    width: 15px;
    vertical-align: sub;
  }
}
.modal-des-2 {
  p {
    font-size: 18px;
    color: #212529;
    font-family: "SF-Pro-Text";
    font-weight: 400;
  }
}
.v--modal-overlay[data-v-a403f004] {
  position: fixed;
}
</style>
